import { DataGridColumn } from 'sharebase/components/dataGrid/dataGrid';
import { ParamType } from 'phoenix/domain/report-type';
import { IconSet } from '../components/dataGrid/dataGrid';

interface FilterData {
	filterPhrase:string;
	columns:DataGridColumn[];
	icons:IconSet
}

export function DataGridFilter() {
	return function getMatchedRows(rows:any[], filterData:FilterData) {
		if (!filterData.filterPhrase) {
			return rows;
		}

		let query = filterData.filterPhrase.toLowerCase();
		let columns = filterData.columns;
		return rows.filter(row => {
			for (let i = 0; i < columns.length; i ++) {
				let prop = columns[i]['propName'];
				let type = columns[i]['dataType'];
				// don't filter on null values, icons, and non-string values
				if (!row[prop] || filterData.icons[prop] || typeof(row[prop]) !== 'string' && !Array.isArray(row[prop])) {
					continue;
				}
				
				let cell = Array.isArray(row[prop]) ? row[prop].join(', ') : row[prop];
				if (cell.toLowerCase().indexOf(query) > -1) {
					return true;
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/filters/dataGrid.ts